module.exports = __webpack_public_path__ + "img/popup-close.2109a3e4.png";